fragment EmailMembershipStatsFragment on AudienceMembershipStats {
    totalCount {
        value
        suffix
        prefix
        formatted
    }
    subscribedCount
    unsubscribedCount
    bouncedCount
    undeliverableCount
    noEmailCount
    duplicateEmailCount
    unsubscribedRate
    newMembersCountCurrentMonth
    unsubscribedCountCurrentMonth
}
